export default __webpack_public_path__ + "static/0-b6acb56132719770e4bc9ff309e959b0.png";